import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'site_settings',
    initialState: {
        logo: null,
        telegram: null,
        instagram: null,
        facebook: null,
        youtube: null,
        twitter: null,
    },
    reducers: {
        getSettings: (state, action) => {
            const data = action.payload
            // DRF list javob formatini qo'llab-quvvatlash
            const list = Array.isArray(data) ? data : (data.results || [])
            if (list.length > 0) {
                const s = list[0]
                state.logo = s.logo
                state.telegram = s.telegram
                state.instagram = s.instagram
                state.facebook = s.facebook
                state.youtube = s.youtube
                state.twitter = s.twitter
            }
        },
    }
})

export const getSiteSettings = () => apiCall({
    url: 'site-settings/',
    method: 'GET',
    onSuccess: slice.actions.getSettings.type
})

export default slice.reducer
